import type { UserGroupsTranslations } from '@/Pages/Groups/types/groupsTranslations.types';

const esES: UserGroupsTranslations = {
  title: 'Crear Grupo',
  description: 'Parametriza la información necesaria para el grupo.',
  editTitle: 'Editar grupo',
  detailsTitle: 'Detalles del grupo',
  editDescription: 'Verifica la información completada abajo y cámbiala si es necesario.',
  cancelAssignmentsButton: 'Cancelar asignación de grupo',
  timeline: {
    permissions: {
      title: 'Permisos',
      administrators: 'Administrador',
      viewers: 'Solo ver',
    },
    stepOne: {
      title: 'Datos del grupo',
      groupName: {
        label: 'Nombre del grupo',
        placeholder: 'Ingresa el nombre de tu grupo',
        helperText:
          'Campo obligatorio. El nombre elegido debe ser único y diferente de cualquier otro ya existente en el sistema. Esto garantiza organización y previene conflictos de información.',
        errors: {
          required: 'El nombre del grupo es obligatorio',
          alreadyExists: 'Este nombre de grupo ya existe',
        },
      },
      groupDescription: {
        label: 'Descripción',
        placeholder: 'Ingresa detalles del grupo',
        helperText: 'Campo opcional para proporcionar más detalles sobre el grupo.',
      },
    },
    stepTwo: {
      title: 'Usuarios',
    },
  },
  transferList: {
    tabs: {
      availables: 'Disponibles',
      assigned: 'Asignados',
    },
    search: {
      placeholder: 'Buscar por nombre de usuario',
    },
    saveButton: 'Guardar cambios',
    emptyState: {
      left: {
        title: 'No hay usuarios disponibles',
      },
      right: {
        title: 'No hay usuarios asignados',
        description: 'Asigna uno o más usuarios a este grupo',
      },
    },
  },
};

export { esES };
